import React, { Component } from 'react';
import CustomTab from 'containers/Tab';
import { TabData } from 'constants/tab';
import { TabPanel } from 'react-tabs';
// import Announcement from './Announcement';
import Banner from './Banner';
import Popup from './Popup';
import ShowDetails from './ShowDetails'
// import Event from './Event';
// import Slider from './Slider';
import AppVersion from './AppVersion';
import * as TabConstants from 'constants/tab';
// import News from './News';

class HomeSettings extends Component {
  state = {
    tabIndex: 0,
    subTabIndex: 0,
  };
  render() {
    return (
      <CustomTab
        selectedIndex={this.state.tabIndex}
        onGetIndex={(ind) => {
          this.setState({ tabIndex: ind }, () => { });
        }}
        wantIndex
        data={TabData.homeSetting.filter((d) => !d.hideTab)}
        tabHeaderClass="customerMaintab"
        className="moreTabScroll"
      >
        <div className="configurationWrapper pt-0">
          <TabPanel>
            <Popup />
          </TabPanel>
          {/* <TabPanel>
            <Event />
          </TabPanel> */}
          {/* <TabPanel>
              <Announcement />
            </TabPanel> */}
          <TabPanel>
            <Banner />
          </TabPanel>

          {/* <TabPanel>
              <SendNotification />
            </TabPanel> */}
          {/* <TabPanel>
            <Slider />
          </TabPanel> */}
          {/*
          <TabPanel>
            <News />
          </TabPanel> */}
          <TabPanel>
            <CustomTab
              className="customerSubTab"
              data={TabConstants.TabData.appVersion[0]}
              title1="1"
              selectedIndex={this.state.subTabIndex}
              selectedClassName="none"
              sub={true}
              wantIndex
              onGetIndex={(ind) => {
                this.setState({ subTabIndex: ind });
              }}
              forceRenderTabPanel={true}
            >
              <TabPanel key="0">{this.state.subTabIndex === 0 && <AppVersion platform={1} />}</TabPanel>
              <TabPanel key="1">{this.state.subTabIndex === 1 && <AppVersion platform={2} />}</TabPanel>
            </CustomTab>
          </TabPanel>
          <TabPanel>
            <ShowDetails />
          </TabPanel>
        </div>
      </CustomTab>
    );
  }
}

export default HomeSettings;
